import { ChatTestimonial } from '../types/content'

export const chatTestimonials: ChatTestimonial[] = [
  {
    id: 'gabriel',
    name: 'Gabriel',
    image: 'https://cdn.magicpatterns.com/uploads/88bQxihfgQ2Do6vYzfyuTh/IMG_0490.png',
    quote: 'Ella volvió y me pidió perdón.',
  },
  {
    id: 'liliana',
    name: 'Liliana',
    image: 'https://cdn.magicpatterns.com/uploads/6cf9gzKwVUKUdXFmQUb8Fp/IMG_0491.png',
    quote: 'Mi pareja volvió, exactamente en los 7 días que me prometió.',
  },
  {
    id: 'santiago',
    name: 'Santiago',
    image: 'https://cdn.magicpatterns.com/uploads/8XfrYuKtL3bCRb3JHYGxQQ/IMG_0492.png',
    quote: 'Decidí darme la oportunidad para volver.',
  },
  {
    id: 'micaela',
    name: 'Micaela',
    image: 'https://cdn.magicpatterns.com/uploads/6UDoegoo8sjBsbXMAZXRUd/IMG_0493.png',
    quote: 'Hace una hora volvió, me dijo que no podía vivir sin mí.',
  },
]

export const reunitedPhotos =
  'https://cdn.magicpatterns.com/uploads/cu2tqL4DWrKb5vSTjricYq/IMG_0497.jpg'
